const e = [];
function s() {
  for (const o of e)
    o();
}
class t {
  add(n) {
    e.length || window.addEventListener("resize", s), e.push(n);
  }
  remove(n) {
    e.splice(e.lastIndexOf(n), 1), console.log(e), e.length || window.removeEventListener("resize", s);
  }
}
const i = new t();
export {
  i as default
};
//# sourceMappingURL=windowResizeListener.mjs.map
